"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemediationStatus = void 0;
var RemediationStatus;
(function (RemediationStatus) {
    RemediationStatus[RemediationStatus["New"] = 1] = "New";
    RemediationStatus[RemediationStatus["In Progress"] = 2] = "In Progress";
    RemediationStatus[RemediationStatus["Completed"] = 4] = "Completed";
})(RemediationStatus = exports.RemediationStatus || (exports.RemediationStatus = {}));
//# sourceMappingURL=RemediationStatus.js.map